/**
 * Determines the opportunity status based on is_closed and is_won flags
 * @param isClosed Whether the opportunity is closed
 * @param isWon Whether the opportunity is won
 * @returns The status of the opportunity: "won", "lost", or "active"
 */
export function getOpportunityStatus(
  isClosed: boolean | null | undefined,
  isWon: boolean | null | undefined,
): "won" | "lost" | "active" {
  if (!isClosed) return "active";
  if (isWon) return "won";
  return "lost";
}

/**
 * Determines the appropriate badge variant for an opportunity
 * @param isClosed Whether the opportunity is closed
 * @param isWon Whether the opportunity is won
 * @returns The badge variant to use
 */
export function getStageVariant(
  isClosed: boolean | null | undefined,
  isWon: boolean | null | undefined,
): "opportunity-won" | "opportunity-lost" | "opportunity-active" {
  const status = getOpportunityStatus(isClosed, isWon);
  return `opportunity-${status}` as const;
}
